import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const createStaffInWarehouse = createAction(ACTION.CREATE_STAFF_IN_WAREHOUSE.REQUEST, (params) => ({...params}));
export const clearState = createAction(ACTION.CLEAR_STATE);
